import { Box, Grid2, Typography } from '@mui/material'
import BalanceCard from 'components/BalanceCard'
import { withdrawFundsPath } from 'components/Routes'
import { activityPath, giftsPath, rechargePath } from 'components/Routes/Routes'
import Recharge from 'components/icons/Recharge'
import RedeemGift from 'components/icons/RedeemGift'
import Withdraw from 'components/icons/Withdraw'
import DefaultLayout from 'components/layout/DefaultLayout'
import { ActivityEntry } from 'api/wallet'
import { useWalletActivity } from 'hooks/useWallet'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ActivityItem from '../Activity/ActivityItem'
import useStyles from './styles'

const DEFAULT_PAGE = 1
const DEFAULT_PER_PAGE = 5

function entryToActivityItem(entry: ActivityEntry) {
  return {
    id: entry.id,
    createdAt: entry.createdAt,
    entries: [
      {
        debit: 0,
        credit: entry.amount,
        source: {
          sourceCategorisation:
            typeof entry.source === 'string' ? entry.source : '',
          sourceInfo: '',
          sourceNote: null
        },
        createdAt: entry.createdAt
      }
    ],
    reference: String(entry.id),
    total: String(entry.amount)
  }
}

export default function Wallet(): JSX.Element {
  const { classes } = useStyles()
  const navigate = useNavigate()

  const walletList = [
    {
      label: 'Deposit',
      icon: <Recharge />,
      path: rechargePath(),
      localStorage: () => localStorage.removeItem('url_after_POLi_transfer')
    },
    {
      label: 'Withdraw',
      icon: <Withdraw />,
      path: withdrawFundsPath()
    },
    {
      label: 'Gift',
      icon: <RedeemGift />,
      path: giftsPath()
    }
  ]

  function handleClickCarousel(path: string, localStorage?: () => void) {
    localStorage && localStorage()
    navigate(path)
  }

  const {
    data: activityForCurrentUserData,
    isLoading: activityForCurrentUserLoading,
    refetch
  } = useWalletActivity(DEFAULT_PAGE, DEFAULT_PER_PAGE)

  const items = activityForCurrentUserData?.entries?.map(entryToActivityItem)

  useEffect(() => {
    refetch()
  }, [refetch])

  const handleClickSeeAllActivities = () => {
    navigate(activityPath())
  }

  return (
    <DefaultLayout
      backgroundColor='white'
      wrapperContent={{ mb: 4, mt: 2, px: 3 }}
      showBackIcon
      noLogo
      headerTitle='My Wallet'
      loading={activityForCurrentUserLoading}
      heading={<BalanceCard />}
    >
      <Grid2 container mt={2}>
        <Grid2 container flexWrap='nowrap' size={{ xs: 12 }} gap={2}>
          {walletList.map(item => (
            <Grid2
              key={item.path}
              className={classes.walletItem}
              onClick={() => handleClickCarousel(item.path, item.localStorage)}
              size={{ xs: 4 }}
            >
              <Box>{item.icon}</Box>
              <Typography>{item.label}</Typography>
            </Grid2>
          ))}
        </Grid2>

        <Grid2
          mt={5}
          container
          size={{ xs: 12 }}
          justifyContent='space-between'
          alignItems='center'
        >
          <Grid2>
            <Typography fontSize='18px' fontWeight={700}>
              Account activity
            </Typography>
          </Grid2>
          <Grid2>
            <Typography
              fontSize='12px'
              color='#757575'
              onClick={handleClickSeeAllActivities}
            >
              See all
            </Typography>
          </Grid2>
        </Grid2>

        <Grid2 size={{ xs: 12 }}>
          <Box mt={1}>
            {items?.length ? (
              items.map(activity => {
                return <ActivityItem key={activity.id} activity={activity} />
              })
            ) : (
              <Box component='section'>
                <Typography component='p'>
                  Your account has no activity yet
                </Typography>
              </Box>
            )}
          </Box>
        </Grid2>
      </Grid2>
    </DefaultLayout>
  )
}
